import { RouterView } from "vue-router";
import { TRANSITIONS } from "@core/constants";
import { LoadingManager } from "@core/managers/loading.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";

import { ETAB_ROUTES } from "@etab/config";
import { ACTION_RECRUITMENT_GET } from "@etab/stores/types";
import { ACTION_TRANSITIONS_SET } from "@core/store/types";
import { useRecruitmentStore } from "@etab/stores/recruitment";
import { useCssTransitionsStore } from "@core/store/modules/cssTransitions";

import ActivationSuccessPage from "./ActivationSuccess.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.recruitment.temporary.activation.root.path,
      name: ETAB_ROUTES.dashboard.recruitment.temporary.activation.root.name,
      component: RouterView,
      children: [
        {
          path: ETAB_ROUTES.dashboard.recruitment.temporary.activation.success.path,
          name: ETAB_ROUTES.dashboard.recruitment.temporary.activation.success.name,
          component: ActivationSuccessPage,
          async beforeEnter(to, from, next) {
            const cssTransitionsStore = useCssTransitionsStore();
            const recruitmentStore = useRecruitmentStore();
            cssTransitionsStore[ACTION_TRANSITIONS_SET](TRANSITIONS.SLIDE.LEFT);
            try {
              LoadingManager.show();
              const demandId = to.params.demandId;
              const demandType = to.params.demandType;
              await recruitmentStore[ACTION_RECRUITMENT_GET]({ demandId, demandType });
              next();
            } catch (error) {
              NotificationsManager.error();
              next({ name: ETAB_ROUTES.dashboard.tabs.root.name });
              throw error;
            } finally {
              LoadingManager.hide();
            }
          },
        },
      ],
    },
  ];
}
